class ProductSlider extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
  
    init() {
      const swiperContainer = this.querySelector('.swiper');
      if (!swiperContainer) return;
  
      const swiper = new Swiper(swiperContainer, {
        direction: 'horizontal',
        loop: true,
  
        // Pagination (dots)
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
          type: 'bullets',
        },
  
        // Scrollbar (optional)
        scrollbar: {
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
      });
  
      // Enable autoplay only on hover
      swiperContainer.addEventListener('mouseenter', () => {
        swiper.autoplay.start(); // Start autoplay on hover
      });
  
      swiperContainer.addEventListener('mouseleave', () => {
        swiper.autoplay.stop(); // Stop autoplay when hover ends
      });
    }
  }
  
  // Define the custom element
  customElements.define('product-slider', ProductSlider);
  